var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.37207,
    y: 20.4023,
    width: 9.08571,
    height: 8.32856,
    fill: "#FF8165"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16823 1.47266H21.0189C21.8575 1.47266 22.5435 2.03015 22.5435 2.71156V7.04795C22.5435 7.72944 21.8575 8.28694 21.0189 8.28694H8.16823C7.3297 8.28694 6.64355 7.72944 6.64355 7.04795V2.71156C6.64355 2.03015 7.3297 1.47266 8.16823 1.47266Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3158 1.625H20.7106C21.5194 1.625 22.1811 2.29698 22.1811 3.11832V8.34521C22.1811 9.16666 21.5194 9.83864 20.7106 9.83864H8.3158C7.50702 9.83864 6.84521 9.16666 6.84521 8.34521V3.11832C6.84521 2.29698 7.50702 1.625 8.3158 1.625Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.377 10.7539V11.5093C20.377 14.3234 24.8875 14.4528 24.8875 16.8612V20.3192",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.952 35.3948H6.27627C5.10296 35.3948 4.13867 34.3999 4.13867 33.1834V17.2731C4.13867 14.6962 8.23988 14.5659 8.23988 11.56V10.7539",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13867 18.9648H13.4271V29.0037H4.13867V18.9648Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1876 17.0911C20.1448 16.6909 21.1979 17.1242 21.6054 18.0194L23.6836 22.5846C23.8727 22.1386 24.2374 21.7571 24.7279 21.5519C25.6001 21.1874 26.5807 21.5015 27.0299 22.2494C27.1762 21.7003 27.5794 21.2132 28.1579 20.9711C29.0298 20.6071 30.0106 20.9212 30.46 21.6688C30.6062 21.1197 31.0094 20.6326 31.5884 20.3907C32.5456 19.9908 33.6848 20.3889 34.006 21.3192L36.3695 28.1642C38.291 33.73 31.4312 39.5992 26.2921 36.2348L17.3777 30.3997C16.5437 29.8541 16.3524 28.7272 16.9521 27.8955C17.9011 27.4993 19.7784 27.5205 20.618 28.0703L22.3063 29.1754L18.1256 19.4737C17.7365 18.5703 18.2307 17.4913 19.1876 17.0911Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/Medicine.8527a2f7021aa0b817da19c6d6fab345.svg";
export { ForwardRef as ReactComponent };